import script from "./itemTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemTable.vue?vue&type=script&setup=true&lang=ts"

import "./itemTable.vue?vue&type=style&index=0&id=b89c3694&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b89c3694"]])

export default __exports__